import { createContext, type ComponentChildren } from 'preact';
import { useContext, useMemo } from 'preact/hooks';
import preventPlpScrolling from '@/utils/preventPlpScrolling';

const WidgetOptionsContext = createContext<any | undefined>(undefined);

export type WidgetOptionsProviderProps<WidgetOptions> = {
  children: ComponentChildren;
  config?: WidgetOptions;
  defaults: WidgetOptions;
};

export function WidgetOptions<WidgetOptions>({
  children,
  config = {} as WidgetOptions,
  defaults
}: WidgetOptionsProviderProps<WidgetOptions>) {
  preventPlpScrolling();

  const resolvedOptions = useMemo(
    () => ({ ...defaults, ...config }),
    [defaults, config]
  );
  return (
    <WidgetOptionsContext.Provider value={resolvedOptions}>
      {children}
    </WidgetOptionsContext.Provider>
  );
}

export default function useWidgetOptions<WidgetOptions>(): WidgetOptions {
  const context = useContext(WidgetOptionsContext);

  if (!context) {
    throw new Error(
      'useWidgetOptions must be used within WidgetOptionsProvider'
    );
  }
  return context;
}
